export default __webpack_public_path__ + "static/media/prbicon_Clientes.1b6c4d04.svg";